import {
  HotelCriteriaEnums,
  TopSportsEnums,
  TopFamilyEnums,
  TopWellnessEnums,
  HotelCriteriaIds,
  TopSportIds,
  TopFamilyIds,
  TopWellnessIds,
} from "@/lib/Types/searchForm";

const HOTEL_CRITERIA_MAP: Record<HotelCriteriaIds, HotelCriteriaEnums> = {
  30: HotelCriteriaEnums.beachLocation,
  32: HotelCriteriaEnums.sandyBeach,
  33: HotelCriteriaEnums.pool,
  44: HotelCriteriaEnums.onlyForAdults,
  46: HotelCriteriaEnums.wlan,
  79: HotelCriteriaEnums.petAllowed,
  80: HotelCriteriaEnums.privatePool,
  81: HotelCriteriaEnums.swimupPool,
  82: HotelCriteriaEnums.atLeastTwoSeparateBedrooms,
  83: HotelCriteriaEnums.separateBedroom,
  101: HotelCriteriaEnums.sustainable,
};

const SPORTS_MAP: Record<TopSportIds, TopSportsEnums> = {
  4: TopSportsEnums.mountainBicycle,
  5: TopSportsEnums.golf,
  7: TopSportsEnums.fitness,
  9: TopSportsEnums.tennisSquash,
  12: TopSportsEnums.waterSport,
  16: TopSportsEnums.surfing,
  17: TopSportsEnums.diving,
  34: TopSportsEnums.indoorSwimmingPool,
};

const FAMILY_MAP: Record<TopFamilyIds, TopFamilyEnums> = {
  19: TopFamilyEnums.familyFriendly,
  20: TopFamilyEnums.childCare,
  21: TopFamilyEnums.animationsProgram,
  22: TopFamilyEnums.childrenPool,
  23: TopFamilyEnums.playground,
  77: TopFamilyEnums.waterSlides,
};

const WELLNESS_MAP: Record<TopWellnessIds, TopWellnessEnums> = {
  39: TopWellnessEnums.massage,
  40: TopWellnessEnums.sauna,
};

export const extractCategoriesData = (categories: string | null) => {
  const categoryIds = categories?.split(",").map(Number).filter(Boolean) ?? [];
  const hotelCriteria: string[] = [];
  const holidayTypes: string[] = [];

  categoryIds.forEach((id) => {
    // Map hotel criteria
    if (id in HOTEL_CRITERIA_MAP) {
      hotelCriteria.push(HOTEL_CRITERIA_MAP[id as HotelCriteriaIds]);
    }
    // Map holiday types (sports, family, wellness)
    else if (id in SPORTS_MAP) {
      holidayTypes.push(SPORTS_MAP[id as TopSportIds]);
    } else if (id in FAMILY_MAP) {
      holidayTypes.push(FAMILY_MAP[id as TopFamilyIds]);
    } else if (id in WELLNESS_MAP) {
      holidayTypes.push(WELLNESS_MAP[id as TopWellnessIds]);
    }
  });

  return {
    hotelCriteria,
    holidayTypes,
  };
};
